<template>
    <div class="one-bd clearfix">
        <router-link to="/wxdataAnalysis">微信账号</router-link>
        <router-link to="/wbdataAnalysis">微博账号</router-link>
        <router-link to="/ttdataAnalysis">头条账号</router-link>
    </div>
</template>
<script>
export default {
    data() {
        return {
           
        }
    },
    mounted() {
		let that = this;
    },
    created() {
		
    },
    methods: {
       
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/dataAnalysis/dataAnalysisMenu.vue